<div *ngIf="!loading">
  <lib-ad-sponsor-banner
    [entityId]="matchDetailViewService.data?.match?.id"
    [entityType]="entityType"
    [sponsors]="matchDetailViewService.sponsors">
  </lib-ad-sponsor-banner>
  <div>
    <h2>Spielvorschau</h2>
    <div
      *ngIf="matchDetailViewService.data.matchPreviewText"
      class="info-card preview-text"
      [innerHTML]="matchDetailViewService.data.matchPreviewText"
    ></div>
    <button
      mat-flat-button
      color="accent"
      class="mt-1"
      (click)="matchDetailViewService.generateMatchPreviewText()"
    >
      {{ matchDetailViewService.data.matchPreviewText ? "Neuen " : "" }}Text
      generieren
    </button>
  </div>
  <div
    *ngIf="getReporterData().visible && fanModerationIsVisible"
    class="register_for_live-ticker">
    <div class="livestream-card mb-1 transparent" *ngIf="showLiveStreamBanner">
      <div class="card-title">
        <mat-icon>play_circle</mat-icon>
        <span>Livestream</span>
      </div>
      <div class="content">
        {{ matchTitle }} wird live übertragen!
        <p>Livestream-Start: <strong>{{ startTimestamp | date : 'HH:mm' }} Uhr</strong></p>
      </div>
    </div>

    <h2>Liveticker übernehmen</h2>
    <div class="info-card mb-1 transparent" *ngIf="showMultipleFanModsInfo">
      <div class="content">
        <p>{{ getRegisteredReporterString() }}</p>
      </div>
      <div class="check-mark">
        <button class="check-mark-button" disabled>
          <img
            src="assets/icons/checkmark-bg-green.svg"
            alt="Icon Check Mark"
          />
        </button>
      </div>
    </div>

    <div class="info-card mb-1" *ngIf="showTeamModRegisteredInfo">
      <div class="content">
        <p>{{ getRegisteredTeamReporterString() }}</p>
      </div>
      <div class="check-mark">
        <button class="check-mark-button" disabled>
          <img
            src="assets/icons/checkmark-bg-green.svg"
            alt="Icon Check Mark"
          />
        </button>
      </div>
    </div>

    <div class="info-card">
      <div class="content">
        <p [innerHTML]="getReporterData().text"></p>
      </div>
      <div class="plus">
        <button class="plus-button" (click)="registerAsReporterClicked()">
          <img [src]="getReporterData().image" alt="Icon Plus" />
        </button>
      </div>
    </div>
  </div>

  <div class="match_infos" *ngIf="matchInfos">
    <h2>Spielinformationen</h2>
    <div class="info-card">
      <div class="table">
        <ng-container *ngFor="let info of matchInfos">
          <div class="t-row" *ngIf="info.visible">
            <span class="title">{{ info.title }}</span>
            <span *ngIf="!info.link">{{ info.text }}</span>
            <a *ngIf="info.link" [href]="info.link">{{ info.text }}</a>
            <span *ngIf="info.subText">, {{ info.subText }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="tipp-question" *ngIf="showPredictionGame()">
    <h2>Tippspiel</h2>
    <div class="info-card" (click)="onPredictionGameClick()">
      <div class="titles">
        <img src="assets/icons/star-bg-blue.svg" alt="Tippspiel"/>
        <h3>Wie geht das Spiel aus?</h3>
      </div>
      <div class="content">
        <div class="team">
          <img [src]="matchDetailViewService.data.homeTeam.getLogoImageUrl('medium')" alt="Team Logo"/>
          <span>{{ matchDetailViewService.data.homeTeam.name }}</span>
        </div>
        <div class="input-fields">
          <input type="text" disabled/>
          <input type="text" disabled/>
        </div>
        <div class="team">
          <img [src]="matchDetailViewService.data.awayTeam.getLogoImageUrl('medium')" alt="Team Logo"/>
          <span>{{ matchDetailViewService.data.awayTeam.name }}</span>
        </div>
      </div>
      <button class="send-tip" disabled (click)="onPredictionGameClick()">
        Tipp abgeben
      </button>
    </div>
    <lib-ad class="mt-2"></lib-ad>
  </div>

  <!--<div class="sponsors" *ngIf="getSponsors()?.length > 0">
    <h2>Spielsponsoren</h2>
    <div class="info-card">
      <swiper class="swiper-container favourites-slider" [config]="config" #sponsorsSlider (indexChange)="onSlideChange($event)">
        <div *ngFor="let sponsor of getSponsors()" class="swiper-slide">
          <div class="sponsor-wrapper">
            <app-team-league-sponsor-card [sponsor]="sponsor"
                                          [simpleDesign]="true"></app-team-league-sponsor-card>
          </div>
        </div>
      </swiper>
    </div>
  </div>-->
</div>
